import { SignIn } from "@clerk/clerk-react";
import { AuthSidebar } from "../components/auth/AuthSidebar";
import { clerkLogoImageUrl } from "../branding/themeAssets";

export function Login() {
  return (
    <div className="flex h-screen flex-1 bg-concrete-50">
      <AuthSidebar />

      <div className="flex flex-1 justify-center items-center">
        <SignIn
          signUpUrl="/signup"
          appearance={{
            elements: {
              rootBox: {
                boxShadow: "none",
              },
              card: {
                boxShadow: "none",
                border: "none",
                background: "transparent",
              },
            },
            layout: {
              socialButtonsPlacement: "bottom",
              logoImageUrl: clerkLogoImageUrl(),
            },
          }}
          afterSignInUrl="/"
        />
      </div>
    </div>
  );
}
